module.exports = __webpack_public_path__ + "img/arrow_right_orange.41c20346.png";